import axios from 'axios';

// 临时硬编码用于测试（请在测试后恢复环境变量方式）
const API_BASE_URL = 'https://data-management-system-production.up.railway.app';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_ENDPOINT = `${API_BASE_URL}/api`;

class AuthServiceClass {
  private token: string = '';

  setToken(token: string) {
    this.token = token;
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  async login(username: string, password: string) {
    console.log('🔍 登录请求发送到:', `${API_ENDPOINT}/auth/login`);

    try {
      const response = await axios.post(`${API_ENDPOINT}/auth/login`, {
        username,
        password,
      });

      console.log('✅ 登录响应:', response.data);
      this.setToken(response.data.token);
      return response.data;
    } catch (error) {
      console.error('❌ 登录错误:', error);
      throw error;
    }
  }

  async register(username: string, password: string, invitationCode: string) {
    console.log('🔍 注册请求发送到:', `${API_ENDPOINT}/auth/register`);

    try {
      const response = await axios.post(`${API_ENDPOINT}/auth/register`, {
        username,
        password,
        invitationCode,
      });

      console.log('✅ 注册响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 注册错误:', error);
      throw error;
    }
  }

  async getUsers() {
    console.log('🔍 获取用户列表请求发送到:', `${API_ENDPOINT}/auth/users`);

    try {
      const response = await axios.get(`${API_ENDPOINT}/auth/users`);

      console.log('✅ 获取用户列表响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 获取用户列表错误:', error);
      throw error;
    }
  }

  // Note: invitation code methods have been deprecated in favor of organization-based invite codes

  async getCurrentUser() {
    console.log('🔍 获取当前用户信息请求发送到:', `${API_ENDPOINT}/auth/me`);

    try {
      const response = await axios.get(`${API_ENDPOINT}/auth/me`);

      console.log('✅ 获取当前用户信息响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 获取当前用户信息错误:', error);
      throw error;
    }
  }

  async updateUser(userId: number, username: string, password: string) {
    console.log('🔍 更新用户请求发送到:', `${API_ENDPOINT}/auth/users/${userId}`);

    try {
      const response = await axios.put(`${API_ENDPOINT}/auth/users/${userId}`, {
        username,
        password,
      });

      console.log('✅ 更新用户响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ 更新用户错误:', error);
      throw error;
    }
  }
}

export const AuthService = new AuthServiceClass();